import { useAppSelector } from '../../../../redux/hooks'
import { useEffect, useState } from 'react'
import {
  getCTXNeighborstatus,
  getCTXNeighborstatusGlobal,
} from '../troubleshooting/request/request'
import { useAuth } from '../../auth'
import styles from '../statusGral/cloudStatusTable.module.scss'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ImportExportIcon from '@mui/icons-material/ImportExport'
// QUITAMOS la importación de CircularProgress de MUI
// import { CircularProgress } from '@mui/material'

type x = {
  Suscription: string
  as: string
  ctxr: string
  ctxr_description?: string | null
  neighbor: string
  description?: string | null
  state: string
  up: string
  local_as: string
  peer_as: string
  in: string
  out: string
}

export default function StatusNeighbors(props: any) {
  const { currentUser } = useAuth()
  const Id = useAppSelector((state) => state.SuscriptionSlice.id)
  const Type = useAppSelector((state) => state.CloudSlice.Type) || 'CloudGlobal'
  const tenant = useAppSelector((state) => state.TenantSlice.id)

  const [Loading, setLoading] = useState(false)
  const [statusNeigh, setstatusNeigh] = useState<x[]>([])

  // Paginación
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)

  // Búsqueda/Filtrado
  const [searchTerm, setSearchTerm] = useState('')
  const [searchColumn, setSearchColumn] = useState('All')

  // Ordenación
  const [sortColumn, setSortColumn] = useState<string>('')
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

  // ------------------- OBTENER DATA AL INICIO -------------------
  useEffect(() => {
    setLoading(true)
    const abortController = new AbortController()
    const signal = abortController.signal

    const fetchData = async () => {
      try {
        let response
        if (
          Id !== 0 &&
          Type !== 'CloudGlobal' &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatus(Id, signal)
        } else if (
          Id !== 0 &&
          Type !== 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatusGlobal(Id, tenant, signal)
        } else if (
          Id === -1 &&
          Type === 'CloudGlobal' &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatus(-1, signal)
        } else if (
          Id === -1 &&
          Type === 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatusGlobal(-1, tenant, signal)
        }
        if (response && !signal.aborted) {
          setstatusNeigh(response.data)
        }
      } catch (error) {
        // Manejo de error
      } finally {
        if (!signal.aborted) setLoading(false)
      }
    }
    fetchData()

    return () => {
      abortController.abort()
    }
  }, [Id, props.id, Type, tenant, currentUser])

  // ------------------- REFRESH (BOTÓN) -------------------
  function reloaddevice() {
    // setSearchTerm('')
    // setCurrentPage(1)

    setLoading(true)
    const abortController = new AbortController()
    const signal = abortController.signal

    const fetchData = async () => {
      try {
        let response
        if (
          Id !== 0 &&
          Type !== 'CloudGlobal' &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatus(Id, signal)
        } else if (
          Id !== 0 &&
          Type !== 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatusGlobal(Id, tenant, signal)
        } else if (
          Id === -1 &&
          Type === 'CloudGlobal' &&
          tenant === 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatus(-1, signal)
        } else if (
          Id === -1 &&
          Type === 'CloudGlobal' &&
          tenant !== 0 &&
          currentUser?.ListPermiso?.includes('CTXR.Neighbor.Status')
        ) {
          response = await getCTXNeighborstatusGlobal(-1, tenant, signal)
        }
        if (response && !signal.aborted) {
          setstatusNeigh(response.data)
        }
      } catch (error) {
        // Manejo de error
      } finally {
        if (!signal.aborted) setLoading(false)
      }
    }
    fetchData()

    return () => {
      abortController.abort()
    }
  }

  // ------------------- ORDENACIÓN -------------------
  const handleSort = (column: string) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
    } else {
      setSortColumn(column)
      setSortDirection('asc')
    }
  }

  const getSortIcon = (col: string) => {
    if (sortColumn === col) {
      return sortDirection === 'asc' ? (
        <KeyboardArrowUpIcon className={styles['sort-icon']} />
      ) : (
        <KeyboardArrowDownIcon className={styles['sort-icon']} />
      )
    } else {
      return (
        <ImportExportIcon
          className={styles['sort-icon']}
          style={{ opacity: 0.7 }}
        />
      )
    }
  }

  function getValueForSort(item: x, column: string): string {
    switch (column) {
      case 'ctxr':
        return item.ctxr.toLowerCase()
      case 'neighbor':
        return item.neighbor.toLowerCase()
      case 'up':
        return item.up.toLowerCase() || item.state.toLowerCase()
      case 'as':
        return (item.local_as ?? '').toString().toLowerCase() ||
          (item.peer_as ?? '').toString().toLowerCase()
      case 'prefix':
        return item.in.toString().toLowerCase() ||
          item.out.toString().toLowerCase()
      default:
        return ''
    }
  }

  function applySort(data: x[]) {
    if (!sortColumn) return data
    return [...data].sort((a, b) => {
      const valA = getValueForSort(a, sortColumn)
      const valB = getValueForSort(b, sortColumn)
      return sortDirection === 'asc'
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA)
    })
  }

  // ------------------- BÚSQUEDA POR COLUMNAS -------------------
  function applySearch(data: x[]) {
    const lowerTerm = searchTerm.toLowerCase()
    return data.filter((d) => {
      if (searchColumn === 'All') {
        return (
          d.ctxr.toLowerCase().includes(lowerTerm) ||
          (d.ctxr_description ?? '').toLowerCase().includes(lowerTerm) ||
          d.neighbor.toLowerCase().includes(lowerTerm) ||
          (d.description ?? '').toLowerCase().includes(lowerTerm) ||
          d.state.toLowerCase().includes(lowerTerm) ||
          d.up.toLowerCase().includes(lowerTerm) ||
          (d.local_as ?? '').toString().toLowerCase().includes(lowerTerm) ||
          (d.peer_as ?? '').toString().toLowerCase().includes(lowerTerm) ||
          (d.in ?? '').toString().toLowerCase().includes(lowerTerm) ||
          (d.out ?? '').toString().toLowerCase().includes(lowerTerm)
        )
      } else {
        let val = ''
        switch (searchColumn) {
          case 'ctxr':
            val = `${d.ctxr} ${d.ctxr_description ?? ''}`.toLowerCase()
            break
          case 'neighbor':
            val = `${d.neighbor} ${d.description ?? ''}`.toLowerCase()
            break
          case 'up':
            val = `${d.state}${d.up}`.toString().toLowerCase()
            break
          case 'as':
            val = `${d.local_as}${d.peer_as}`.toString().toLowerCase()
            break
          case 'prefix':
            val = `${d.in}${d.out}`.toString().toLowerCase()
            break
          default:
            val = ''
        }
        return val.includes(lowerTerm)
      }
    })
  }

  // ------------------- PAGINACIÓN -------------------
  const totalItems = statusNeigh.length
  const [currentRecords, setCurrentRecords] = useState<x[]>([])
  const [sortedData, setSortedData] = useState<x[]>([])

  const handlePageChange = (page: number) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page)
    }
  }

  const handleRecordsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setItemsPerPage(Number(e.target.value))
    setCurrentPage(1)
  }

  const totalPages = Math.ceil(sortedData.length / itemsPerPage)
  const startIndex = (currentPage - 1) * itemsPerPage
  const endIndex = startIndex + itemsPerPage

  // ------------------- PROCESAR DATA FINAL -------------------
  useEffect(() => {
    // 1) Filtrar con la búsqueda
    const searchedData = applySearch(statusNeigh)
    // 2) Ordenar
    const orderData = applySort(searchedData)
    setSortedData(orderData)
  }, [statusNeigh, searchTerm, searchColumn, sortColumn, sortDirection])

  useEffect(() => {
    // Ajustar el array a la página actual
    const slice = sortedData.slice(startIndex, endIndex)
    setCurrentRecords(slice)
  }, [sortedData, currentPage, itemsPerPage, startIndex, endIndex])

  return (
    <div
      className="card"
      style={{
        minHeight: '75vh',
        position: 'relative', // Para el overlay
      }}
    >
      {/* HEADER */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span className="f-titulo text-marino fs-md">BGP Neighbors Status</span>
        </h3>
        <div className="d-flex align-items-center">
          <button
            className="btn-light-marino f-parrafo"
            style={{ marginLeft: '10px' }}
            onClick={reloaddevice}
          >
            <i className="text-gray-100 bi bi-arrow-clockwise"></i>
          </button>
        </div>
      </div>

      {/* BODY */}
      <div className="card-body py-3">
        <div className="tab-content">
          {statusNeigh.length > 0 && (
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
                marginRight: '5px',
              }}
            >
              <div>
                <span className="text-marino f-parrafo fw-semibold">
                  Total Records: {sortedData.length}
                </span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', height: '30px' }}>
                <div
                  className="input-group custom-search-group"
                  style={{ display: 'flex', height: '30px' }}
                >
                  <span
                    className="input-group-text"
                    style={{
                      justifyContent: 'center',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                    }}
                  >
                    <i
                      className="bi-search"
                      style={{ fontSize: '1rem', color: '#FF4089', verticalAlign: 'middle' }}
                    ></i>
                  </span>
                  <select
                    className="form-select"
                    style={{
                      border: '1px solid var(--bs-gray-300)',
                      width: '135px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem',
                    }}
                    value={searchColumn}
                    onChange={(e) => {
                      setSearchColumn(e.target.value)
                      setCurrentPage(1)
                    }}
                  >
                    <option value="All">All</option>
                    <option value="ctxr">CTX-R</option>
                    <option value="neighbor">Neighbor</option>
                    <option value="up">Status/Time</option>
                    <option value="as">Local/Peer AS</option>
                    <option value="prefix">Prefix RcV/Snt</option>
                  </select>
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      width: '150px',
                      height: '30px',
                      lineHeight: '30px',
                      padding: '0 8px',
                      fontSize: '0.875rem',
                    }}
                    placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn}`}
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value)
                      setCurrentPage(1)
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          {/* TABLA */}
          <div className="table-responsive">
            {statusNeigh.length === 0 ? (
              <div className="no-data-message">No Data Available</div>
            ) : (
              <>
                <table className="w-full f-parrafo caption-bottom custom-table">
                  <thead>
                    <tr className="text-azul">
                      <th
                        className="table-cell"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('ctxr')}
                      >
                        <div className={styles['header-content']}>
                          <span>CTX-R / Description</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('ctxr')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('neighbor')}
                      >
                        <div className={styles['header-content']}>
                          <span>Neighbor / Description</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('neighbor')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('up')}
                      >
                        <div className={styles['header-content']}>
                          <span>Status/Time</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('up')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('as')}
                      >
                        <div className={styles['header-content']}>
                          <span>Local AS/Peer AS</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('as')}
                          </span>
                        </div>
                      </th>
                      <th
                        className="table-cell"
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleSort('prefix')}
                      >
                        <div className={styles['header-content']}>
                          <span>Prefix RvC/Snt</span>
                          <span className={styles['sortable-column']}>
                            {getSortIcon('prefix')}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentRecords.length === 0 ? (
                      <tr>
                        <td
                          colSpan={5}
                          style={{
                            textAlign: 'center',
                            color: 'gray',
                            padding: '20px',
                          }}
                        >
                          No Data Available
                        </td>
                      </tr>
                    ) : (
                      currentRecords.map((d, i) => (
                        <tr key={i} className="table-row">
                          <td className="table-cell">
                            <div>
                              <span>{d.ctxr}</span>
                              {d.ctxr_description && (
                                <>
                                  {' '} /
                                  <br />
                                  <span style={{ color: '#777', fontSize: '0.85em' }}>
                                    {d.ctxr_description}
                                  </span>
                                </>
                              )}
                            </div>
                          </td>
                          <td className="table-cell">
                            <div>
                              <span>{d.neighbor}</span>
                              {d.description && (
                                <>
                                  {' '} /
                                  <br />
                                  <span style={{ color: '#777', fontSize: '0.85em' }}>
                                    {d.description}
                                  </span>
                                </>
                              )}
                            </div>
                          </td>
                          <td className="table-cell">
                            <div>
                              <span>{d.state}</span>
                              {d.up && (
                                <>
                                  {' '} /
                                  <br />
                                  <span style={{ color: '#777', fontSize: '0.85em' }}>
                                    {d.up}
                                  </span>
                                </>
                              )}
                            </div>
                          </td>
                          <td className="table-cell">
                            {d.local_as} / {d.peer_as}
                          </td>
                          <td className="table-cell">
                            {d.in} / {d.out}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>

                {/* Paginación */}
                {sortedData.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginTop: '10px',
                    }}
                  >
                    <div>
                      {currentPage > 1 && (
                        <button
                          onClick={() => handlePageChange(currentPage - 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Previous
                        </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span>
                        Page {currentPage} of {totalPages}
                      </span>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                      {currentPage < totalPages && (
                        <button
                          onClick={() => handlePageChange(currentPage + 1)}
                          className={`btn btn-secondary ${styles.buttonRows}`}
                        >
                          Next
                        </button>
                      )}
                      <div className={`select-container ${styles.selectContainer}`}>
                        <select
                          className={`custom-select aligned-select text-center ${styles.selectStyle}`}
                          aria-label="Select items per page"
                          value={itemsPerPage}
                          onChange={handleRecordsPerPageChange}
                        >
                          <option value={5}>5 rows</option>
                          <option value={10}>10 rows</option>
                          <option value={20}>20 rows</option>
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>

          {/* Caso en que no hay una suscripción válida */}
          {Id === 0 && Type !== 'CloudGlobal' && (
            <table className="table table-striped gy-7 gs-7">
              <tbody>
                <div className="text-center">
                  Select a Cloud with available subscriptions
                </div>
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Mantengo el overlay, PERO sin usar el CircularProgress de MUI */}
      {Loading && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255, 255, 255, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 99,
          }}
        >
        </div>
      )}
    </div>
  )
}
